import * as React from "react";
import { UpsellCategoryContainer } from "../../../../containers/modules/Upsell/containers/UpsellCategoryContainer.js";
const UpsellCategory = ({ recommendedCategoryKey }) => /* @__PURE__ */ React.createElement("div", { className: "upsell" }, /* @__PURE__ */ React.createElement("div", { className: "upsell__content" }, /* @__PURE__ */ React.createElement(UpsellCategoryContainer, { categoryKey: recommendedCategoryKey })));
export {
  UpsellCategory
};
//# sourceMappingURL=UpsellCategory.js.map
